/** Display formatting shared by every table and detail panel. */

/** Format an ISO timestamp for display, or return a dash when absent. */
export function formatDateTime(value: string | null): string {
  if (!value) return '—';
  return new Date(value).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

/** A file size for people: 820 B, 14 KB, 3.2 MB. */
export function formatBytes(bytes: number): string {
  if (bytes < 1000) return `${bytes} B`;
  if (bytes < 1_000_000) return `${Math.round(bytes / 1000)} KB`;
  return `${(bytes / 1_000_000).toFixed(1)} MB`;
}

/** Format a number with thousands separators. */
export function formatNumber(value: number): string {
  return value.toLocaleString();
}

/** "formaspace.com" from "https://www.formaspace.com/". Falls back to the input. */
export function siteHost(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

/**
 * "Aiden — formaspace.com". Bot names are assistant personas, so on their own
 * they don't say which website is meant; everywhere a bot is chosen or
 * labelled, the site goes alongside.
 */
export function botLabel(bot: { name: string; site_url: string }): string {
  const host = siteHost(bot.site_url);
  return host ? `${bot.name} — ${host}` : bot.name;
}
